import { readCookie, createCookie } from "./functions";

/**
 * Rating Popup Manager
 * Handles showRating cookie configuration and management for rating popup display
 */
class RatingPopupManager {
	constructor() {
		this.cookieName = "showRating";
		this.cookieValue = true;
		this.cookieExpiry = 604800; // 7 days in seconds
		this.cookiePath = "/";
	}

	initializeRatingCookie() {
		const showPopup = readCookie(this.cookieName);

		if (!showPopup) {
			createCookie(
				this.cookieName,
				this.cookieValue,
				true,
				this.cookieExpiry,
				this.cookiePath
			);
		}
	}

	shouldShowRatingPopup() {
		const showPopup = readCookie(this.cookieName);
		return !showPopup;
	}

	setRatingPopupShown() {
		createCookie(
			this.cookieName,
			false,
			true,
			this.cookieExpiry,
			this.cookiePath
		);
	}

	resetRatingPopup() {
		createCookie(
			this.cookieName,
			true,
			true,
			this.cookieExpiry,
			this.cookiePath
		);
	}
}

const ratingPopupManager = new RatingPopupManager();

export default ratingPopupManager;
export { RatingPopupManager };
